import styled, { css } from 'styled-components';
import { fromMd, timingDefault } from '../../constants';
import { focusOutline } from '../../utility-classes';
export const Container = styled.div `
  font-weight: 700;
`;
export const sharedInputStyles = css `
  appearance: none;
  border-color: ${({ $isEmpty, $isInvalid, theme }) => $isInvalid
    ? theme.color.stroke.critical.text.on.background
    : $isEmpty
        ? theme.color.stroke.neutral.border.interaction.secondary.on.background
        : theme.color.stroke.neutral.border.interaction.primary.on.background};
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  font-family: ${o => o.theme.typography.deprecated.font.family.primary};
  font-size: 16px;
  letter-spacing: 0.6px;
  padding: 4px 16px;
  transition: border-color ${timingDefault} ease;
  width: 100%;
  min-height: 42px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  ${fromMd} {
    font-size: 13px;
  }

  &:disabled {
    background-color: ${o => o.theme.color.fill.subtle};
  }

  ${focusOutline};
`;
export const StyledInput = styled.input `
  ${sharedInputStyles}
`;
export const StyledTextArea = styled.textarea `
  ${sharedInputStyles}
  height: 110px;
  min-height: 110px;
  resize: vertical;
`;
export const ErrorMessage = styled.span `
  color: ${o => o.theme.color.text.critical.on.background};
  display: block;
  font-size: 11px;
  letter-spacing: 1px;
  padding-top: 8px;
  font-weight: 700;
`;
//# sourceMappingURL=styles.js.map